export enum ProductCopyType {
  CreateCopy = 'create-copy',
  CopyData = 'copy-data',
}
